<div class="offre-background">
  <img src="assets/wavehome.png" alt="Décor wavehome" class="decor-wavehome" />
</div>

<section class="a-propos-intro">
  <div class="a-propos-container">
    <p class="a-propos-phrase">
      Parce qu’un hôtel serein commence par des rondes intelligentes et sécurisées.
    </p>
    <p class="a-propos-phrase">
      Nous facilitons le quotidien de vos équipes et rassurons vos voyageurs.
    </p>
  </div>
</section>

<section class="a-propos-engagements">
  <h2 class="engagements-title">Nos engagements</h2>
  <p class="engagements-subtitle">Un service pensé par le terrain, pour le terrain.</p>

  <div class="engagements-grid">
    <div class="engagement-item">
      <img src="assets/icons/lune.png" alt="Icône Sérénité" class="engagement-icon-img" />
      <h3>Sérénité</h3>
      <p>Un établissement sécurisé, des équipes rassurées</p>
    </div>
    <div class="engagement-item">
      <img src="assets/icons/ecrou.png" alt="Icône Simplicité" class="engagement-icon-img" />
      <h3>Simplicité</h3>
      <p>Une interface conçue pour aller à l’essentiel, même dans l’urgence.</p>
    </div>
    <div class="engagement-item">
      <img src="assets/icons/fleche.png" alt="Icône Efficacité" class="engagement-icon-img" />
      <h3>Efficacité</h3>
      <p>Moins d'oublis, plus de réactivité.</p>
    </div>
    <div class="engagement-item">
      <img src="assets/icons/bulle.png" alt="Icône Écoute" class="engagement-icon-img" />
      <h3>Écoute</h3>
      <p>Développée à partir des besoins réels du terrain.</p>
    </div>
  </div>
</section>

<section class="a-propos-history-section">
  <div class="a-propos-history-bg"></div>
  <div class="a-propos-history-content">
    <h2 class="history-title">Notre histoire</h2>
    <p class="history-text">
      En 2025, trois professionnels de l’hôtellerie se heurtent à la même frustration :<br />
      <strong
        >l’absence de traçabilité claire pour les événements techniques ou de sûreté survenant en
        dehors des horaires classiques.</strong
      >
    </p>
    <ul class="history-founders">
      <li><strong>Loïc</strong>, Responsable Technique</li>
      <li><strong>Antony</strong>, Responsable Hébergement</li>
      <li><strong>Théry</strong>, Assistant Responsable Hébergement et développeur</li>
    </ul>
    <p class="history-text">
      Décident alors d’unir leurs compétences pour créer <strong>Qaryos</strong>, première solution
      imaginée par et pour les équipes hôtelières afin de fluidifier la gestion des aléas
      opérationnels en continu.
    </p>
    <h3 class="history-subtitle">De l’idée au prototype</h3>
    <p class="history-text">
      Guidé par l’expérience terrain de Loïc et d'Antony ainsi que le savoir-faire numérique de
      Thery, Qaryos naît sous la forme d’une application mobile :
    </p>
    <ul class="history-list">
      <li>Interface épurée et intuitive</li>
      <li>Scan horodaté à chaque passage</li>
      <li>
        Circuit de ronde pensé pour être optimal :<br />
        fluide pour les équipes, rassurant pour la direction et protecteur pour tous
      </li>
      <li>
        Rapports quotidiens automatiques pour la direction, véritable tableau de bord Indicatif
      </li>
    </ul>
    <h3 class="history-subtitle">Premiers déploiements</h3>
    <p class="history-text">
      La version pilote séduit rapidement plusieurs établissements qui constatent :
    </p>
    <ul class="history-list">
      <li>
        <strong>Équipes terrain :</strong> moins de déplacements inutiles, échanges simplifiés,
        stress réduit
      </li>
      <li>
        <strong>Direction :</strong> visibilité totale, anticipation des coûts imprévus, meilleures
        décisions
      </li>
      <li>
        <strong>Clients :</strong> sentiment de sécurité renforcé et service encore plus réactif
      </li>
    </ul>
    <h3 class="history-subtitle">Notre vision</h3>
    <p class="history-text">
      Parce qu’aucune solution comparable n’existait encore dans l’hôtellerie, Qaryos s’est donné
      pour mission de devenir le standard de la traçabilité opérationnelle pour les hôtels,
      résidences et auberges. L’équipe améliore sans cesse la plateforme, convaincue que la
      transparence des opérations est la clé d’un service d’excellence.
    </p>
    <p class="history-signature">
      <strong>Qaryos</strong> — "Veillez sereinement, nous veillons sur tout le reste."
    </p>
  </div>
</section>

<section class="a-propos-team">
  <h2 class="team-title">L'équipe fondatrice</h2>
  <div class="team-grid">
    <div class="team-member">
      <img src="assets/team/loic.jpg" alt="Loïc, Responsable Technique" class="team-photo" />
      <h3>Loïc</h3>
      <p class="team-role">Responsable Technique</p>
      <p class="team-desc">
        Il assure le suivi opérationnel et la sécurité de l’établissement. Expert technique reconnu
        et diplômé SSIAP. Il optimise le fonctionnement des équipements, anticipe les incidents et
        accompagne les équipes au quotidien. Initiateur du projet, il veille à ce que Qaryos apporte
        des solutions concrètes aux besoins du terrain.
      </p>
    </div>
    <div class="team-member">
      <img src="assets/team/antony.jpg" alt="Antony, Responsable Hébergement" class="team-photo" />
      <h3>Antony</h3>
      <p class="team-role">Responsable Hébergement</p>
      <p class="team-desc">
        Pilote des opérations d’hébergement, Antony encadre l’ensemble des équipes y compris les
        veilleurs de nuit. Il veille à la coordination fluide entre services. Son expérience du
        terrain et sa vision globale ont permis d’orienter Qaryos vers une solution qui profite à
        tous.
      </p>
    </div>
    <div class="team-member">
      <img
        src="assets/team/thery.jpg"
        alt="Théry, Assistant Resp. Hébergement & Développeur"
        class="team-photo"
      />
      <h3>Thery</h3>
      <p class="team-role">Assistant Resp. Hébergement & Développeur</p>
      <p class="team-desc">
        À la fois proche des équipes et des clients, Thery associe expertise digitale, expérience de
        la réception et management de terrain pour concevoir une solution Qaryos ergonomique,
        pratique et en constante évolution.
      </p>
    </div>
  </div>
</section>
